import { Clock, ChevronRight } from 'lucide-react'
import { useGames } from '../hooks/useGames'
import { hexToRgba } from '../utils/colors'

export default function GameHistory({ onSelectGame }) {
  const { data: games, isLoading } = useGames()
  const completedGames = games?.filter((g) => g.status === 'completed') || []

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem' }}>
        Game History
      </h1>

      {isLoading ? (
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '2rem' }}>Loading...</p>
      ) : !completedGames.length ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '40vh',
          gap: '1rem',
          textAlign: 'center',
          color: 'var(--text-muted)',
        }}>
          <Clock size={48} />
          <p style={{ fontSize: '0.875rem' }}>No games played yet</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {completedGames.map((game) => (
            <button
              key={game.id}
              onClick={() => onSelectGame(game.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '1rem',
                backgroundColor: 'var(--bg-secondary)',
                borderRadius: '9999px',
                border: '1px solid var(--border-color)',
                textAlign: 'left',
                width: '100%',
                minHeight: '64px',
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: '600', fontSize: '0.9375rem', marginBottom: '0.25rem' }}>
                  {game.game_name || game.course_name || 'Untitled Game'}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                  <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>
                    {new Date(game.completed_at || game.created_at).toLocaleDateString()}
                  </span>
                  <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem' }}>
                    {game.num_holes} holes
                  </span>
                  {game.game_players?.length > 0 && (
                    <div style={{ display: 'flex', gap: '-0.25rem' }}>
                      {game.game_players.slice(0, 4).map(({ player }) => player && (
                        <div
                          key={player.id}
                          style={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '50%',
                            backgroundColor: player.avatar_color,
                            marginLeft: '-4px',
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <ChevronRight size={20} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
